<div>
    <div [formGroup]="form">
    <div class="controls">
      <mat-form-field>
        <mat-label>Выберите исходный университет</mat-label>
        <input matInput type="text" formControlName="university" (click)="getUniversity()" readonly autocomplete="false">
        <!--input matInput type="text" formControlName="university" [matAutocomplete]="auto2">
        <mat-autocomplete #auto2="matAutocomplete">
          <mat-option *ngFor="let option of filteredUniversities | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete-->
      </mat-form-field>

    <div class="input-group">
      <div *ngIf="form.controls.indicators.value.length > 0 else noSelectedRef">
        Параметры для сопоставления:
        <b>{{form.value.indicators.length ? form.value.indicators[0] : ''}}
        <span *ngIf="form.value.indicators?.length > 1">и ещё {{form.value.indicators.length - 1}}</span></b>
      </div>
      <ng-template #noSelectedRef><div>Индикаторы не выбраны</div></ng-template>
    </div>
    <div class="input-group">
      <button mat-raised-button
              color="primary"
              (click)="selectIndicators()">Выбрать индикаторы для сопоставления</button>
    </div>
    <div class="input-group">
      <div class="flex-between">
        <div style="width: 60%; margin-right: 1em;">
          <mat-form-field>
            <mat-label>Задать количество университетов (от 1 до {{ universitiesCount }})</mat-label>
            <input matInput type="number" formControlName="count" autocomplete="off" min="1" [max]="universitiesCount">
          </mat-form-field>
        </div>
        <div>
          <div class="button_group">
            <button mat-raised-button
                  color="primary"
                  [disabled]="form.invalid"
                  (click)="loadFiltered()" style="margin-right:10px;">Сформировать группу
            </button>
            <mat-icon color="help" matTooltip="Сформировать группу вузов, наиболее близких к исходному университетов по заданным индикаторам">help</mat-icon>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
    <mat-dialog-content>
    <div *ngIf="loading" class="center"><mat-spinner [diameter]="30"></mat-spinner></div>

    <table mat-table *ngIf="loaded" [dataSource]="dataSource">
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef> Страна </th>
        <td mat-cell *matCellDef="let element"> {{element.country}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Университет </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </mat-dialog-content>
</div>
<mat-dialog-actions>
  <div>
    <div class="button_wrap" [matTooltip]="form.invalid ? 'Для сохранения выберите исходный университет, индикаторы и количество' : ''">
      <button mat-raised-button
              color="primary"
              [disabled]="form.invalid"
              (click)="complete()">{{ buttonLabel }}
      </button>
    </div>
    <span class="var-label" *ngIf="loaded">
      {{ varLabel }}
    </span>
  </div>
</mat-dialog-actions>
